import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const addonsEmceePublicRoute: InvariantJiraRoute = {
	name: 'addons-emcee-public',
	path: '/plugins/servlet/ac/com.atlassian.jira.emcee/enduser-discover',
};
